// extracted by mini-css-extract-plugin
export default {"modalContainer":"InformativeModal_modalContainer__j3P19","leftContainer":"InformativeModal_leftContainer__AuavA","rightContainer":"InformativeModal_rightContainer__rA89U"};